export default __webpack_public_path__ + "static/media/message.3b9180c9.svg";